import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import GoogleMapReact from 'google-map-react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FeatherIcon from 'feather-icons-react';
import ContactUS from 'assets/images/contactUS.png';
import ConttUS from 'assets/images/ContactUS1.png';
import ConttUS1 from 'assets/images/ContactUs2.png';
// import ConttUS3 from 'assets/images/hero/New folder/Home/contactUs3.png';
import ContactUs3 from 'assets/images/hero/New folder/contactUs3.jpg'


import { toast } from 'react-toastify';
import "./Contact.css";

// components
import { FormInput } from 'components/form';
import { EnquiryDetails } from 'helpers/api/ContactService';
import { useRef, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { EnquiryDemoDetails } from 'helpers/api/ContactServices1';
import { colors } from 'styles/colors';

const ContactUs = () => {
    // const recaptchaRef = useRef(null);
    const [captchaStatus, setCaptchaStatus] = useState(false)
    const [captchaToken, setToken] = useState('')
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const schemaResolver = yupResolver(
        yup.object().shape({
            ComName: yup.string().required('Please enter company name'),
            fname: yup.string().required('Please enter first name'),
            lname: yup.string().required('Please enter last name'),
            Cnumber: yup.string().required('Please enter number'),
            email: yup.string().required('Please enter Email').email('Please enter valid Email'),
            message: yup.string().required('Please enter Message'),
        })
    );

    // form method
    const methods = useForm({ resolver: schemaResolver });
    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        reset,
    } = methods;


    const recaptchaRef = useRef<ReCAPTCHA | null>(null);
    const onSubmit = async (data: any) => {
        setLoading(true);
        if (!captchaStatus || !captchaToken) {
            toast.warning("Please complete the CAPTCHA verification.");
            setLoading(false);
            return;
        }
        try {
            const response = await EnquiryDemoDetails(data);
            if (response.success) {
                setSubmitted(true);
                toast.success("Thank you for contacting us! We’ll get back to you shortly.");
                reset();
                setCaptchaStatus(false);
                setToken('');
                if (recaptchaRef.current) {
                    recaptchaRef.current.reset();
                }
            } else {
                console.error('Enquiry submission failed:', response.message || 'Unknown error');
                toast.error('Failed to submit inquiry. Please try again.');
            }
        } catch (error) {
            toast.error('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const onChange = (value: any) => {
        setToken(value);
        setCaptchaStatus(true)
    }

    return (
        <>
            {/* <section className="section pb-lg-7 py-4 position-relative">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={6}>
                            <Card className="shadow-none">
                                <Card.Body className="p-xl-5 p-0">
                                    {!submitted ? (
                                        loading ? (

                                            <div className="text-center py-5">

                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Submitting...</span>
                                                </div>
                                                <p className="mt-3">Submitting your information...</p>
                                            </div>
                                        ) : (
                                            <>
                                                <div className='p-2'>


                                                    <h2 className="mb-2 mt-0 fw-medium">Let's Talk Further</h2>
                                                    <p className="mb-5">
                                                        Please fill out the following form and we will get back to you shortly
                                                    </p>

                                                    <form onSubmit={handleSubmit(onSubmit)}>
                                                        <Row>
                                                            <Col lg={12}>
                                                                <FormInput
                                                                    type="text"
                                                                    name="ComName"
                                                                    label="Company Name"
                                                                    placeholder="Enter Company Name"
                                                                    containerClass={'mb-3'}
                                                                    register={register}
                                                                    errors={errors}
                                                                    control={control}
                                                                />
                                                            </Col>

                                                            <Col md={6}>
                                                                <FormInput
                                                                    type="text"
                                                                    name="fname"
                                                                    label="First Name"
                                                                    placeholder="Your First Name"
                                                                    containerClass={'mb-3'}
                                                                    register={register}
                                                                    errors={errors}
                                                                    control={control}
                                                                />
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormInput
                                                                    type="text"
                                                                    name="lname"
                                                                    label="Last Name"
                                                                    placeholder="Your Last Name"
                                                                    containerClass={'mb-3'}
                                                                    register={register}
                                                                    errors={errors}
                                                                    control={control}
                                                                />
                                                            </Col>
                                                            <Col lg={12}>
                                                                <FormInput
                                                                    type="email"
                                                                    name="email"
                                                                    label="Email"
                                                                    placeholder="Your Email"
                                                                    containerClass={'mb-3'}
                                                                    register={register}
                                                                    errors={errors}
                                                                    control={control}
                                                                />
                                                            </Col>
                                                            <Col lg={12}>
                                                                <FormInput
                                                                    type="text"
                                                                    name="Cnumber"
                                                                    label="Contact Number"
                                                                    maxLength={10}
                                                                    placeholder="Your Contact Number"
                                                                    containerClass={'mb-3'}
                                                                    register={register}
                                                                    errors={errors}
                                                                    control={control}
                                                                />
                                                            </Col>
                                                            <Col lg={12}>
                                                                <FormInput
                                                                    type="textarea"
                                                                    name="message"
                                                                    label="Message"
                                                                    placeholder="Type Your message..."
                                                                    rows={5}
                                                                    containerClass={'mb-3'}
                                                                    register={register}
                                                                    errors={errors}
                                                                    control={control}
                                                                />
                                                            </Col>


                                                            <Col lg="auto" className="mb-0 ">
                                                                <ReCAPTCHA
                                                                    ref={recaptchaRef}

                                                                    sitekey="6Lchm_4qAAAAAGOEl-D9UqjqMyFAAuYFvORjkwmw"

                                                                    onChange={onChange}
                                                                />


                                                                <Button type="submit" style={{ marginTop: 12 }} disabled={loading}>
                                                                    {loading ? (
                                                                        <div className="spinner-border spinner-border-sm text-white" role="status">
                                                                            <span className="visually-hidden">Loading...</span>
                                                                        </div>
                                                                    ) : (
                                                                        'Send'
                                                                    )}
                                                                    <span className="icon icon-xs text-white ms-1">
                                                                        <FeatherIcon icon="send" />
                                                                    </span>
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </form>

                                                </div>

                                            </>

                                        )
                                    ) : (

                                        <div className="text-center p-5 bg-light rounded shadow-sm border border-success">
                                            <div className="mb-3">
                                                <FeatherIcon icon="check-circle" size={48} className="text-success" />
                                            </div>
                                            <h4 className="text-success fw-bold">Thank You!</h4>
                                            <p className="mt-3 text-muted fs-5">
                                                Your information has been successfully submitted. <br />
                                                Someone from our team will contact you within 24 hours.
                                            </p>
                                        </div>

                                    )}

                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={{ offset: 1, span: 5 }}>

                            <div className="img-content2 position-relative" >
                                <div className="img-up">
                                    <img
                                        src={ContactUs3}
                                        loading="lazy"
                                        alt="app img"
                                        className="img-fluid d-block rounded"
                                        data-aos="fade-left"
                                        data-aos-duration="300"
                                    />
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <Row className="mt-5 align-items-center">
                        <Col md={4}>
                            <div className="d-flex px-md-1 px-lg-5 mb-md-0 mb-3">
                                <span className="bg-soft-primary avatar avatar-sm rounded icon icon-with-bg icon-xs text-primary me-3 flex-shrink-0">
                                    <FeatherIcon icon="mail" className="icon-dual-primary" />
                                </span>
                                <div className="flex-grow-1">
                                    <h5 className="m-0 fw-medium">Email</h5>
                                    <Link to="#" className="text-muted fw-normal h5 my-1">
                                        hello@salestrackify.com
                                    </Link>
                                </div>
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="d-flex px-md-1 px-lg-5 mb-md-0 mb-3">
                                <span className="bg-soft-orange avatar avatar-sm rounded icon icon-with-bg icon-xs text-orange me-3 flex-shrink-0">
                                    <FeatherIcon icon="phone-call" className="icon-dual-orange" />
                                </span>
                                <div className="flex-grow-1">
                                    <h5 className="m-0 fw-medium">Phone</h5>
                                    <Link to="#" className="text-muted fw-normal h5 my-1">
                                        +44 7775168068
                                    </Link>
                                </div>
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="d-flex px-md-1 px-lg-5 mb-md-0 mb-3">
                                <span className="bg-soft-info avatar avatar-sm rounded icon icon-with-bg icon-xs text-info me-3 flex-shrink-0">
                                    <FeatherIcon icon="map-pin" className="icon-dual-info" />
                                </span>
                                <div className="flex-grow-1">
                                    <h5 className="m-0 fw-medium">Address</h5>
                                    <Link to="#" className="text-muted fw-normal h5 my-1">
                                        Rugby, UK.
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}

            <section className="">
                <main className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
                    {/* <div className="grid gap-5 lg:grid-cols-2"> */}
                    <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10">
                        {!submitted ? (
                            loading ? (
                                <div className="text-center py-5">

                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Submitting...</span>
                                    </div>
                                    <p className="mt-3">Submitting your information...</p>
                                </div>
                            ) : (
                                <>
                                    {/* LEFT - Contact Form */}
                                    {/* <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-lg"> */}
                                    <div className="rounded-3xl border border-slate-200 bg-white p-4 sm:p-5 md:p-6 shadow-lg w-full">
                                        {/* <h2 className="text-3xl font-bold text-slate-900"> */}
                                        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">
                                            Send a message</h2>
                                        <p className="mt-2 text-slate-600">We typically respond within 1 business day.</p>

                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <Row className="mt-4" data-aos="fade-up">
                                                <Col lg={12}>
                                                    <FormInput
                                                        type="text"
                                                        className="mt-1.5 w-full rounded-lg border border-slate-300 px-4 py-2.5 text-sm outline-none focus:border-[#26A2AB] focus:ring-1 focus:ring-[#26A2AB]"
                                                        name="ComName"
                                                        label="Company Name"
                                                        placeholder="Enter Company Name"
                                                        containerClass={'mb-3'}
                                                        register={register}
                                                        errors={errors}
                                                        control={control}
                                                    />
                                                </Col>

                                                <Col md={6}>
                                                    <FormInput
                                                        type="text"
                                                        name="fname"
                                                        label="First Name"
                                                        placeholder="Your First Name"
                                                        containerClass={'mb-3'}
                                                        register={register}
                                                        errors={errors}
                                                        control={control}
                                                        className="mt-1.5 w-full rounded-lg border border-slate-300 px-4 py-2.5 text-sm outline-none focus:border-[#26A2AB] focus:ring-1 focus:ring-[#26A2AB]"
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <FormInput
                                                        type="text"
                                                        name="lname"
                                                        label="Last Name"
                                                        placeholder="Your Last Name"
                                                        containerClass={'mb-3'}
                                                        register={register}
                                                        errors={errors}
                                                        control={control}
                                                        className="mt-1.5 w-full rounded-lg border border-slate-300 px-4 py-2.5 text-sm outline-none focus:border-[#26A2AB] focus:ring-1 focus:ring-[#26A2AB]"
                                                    />
                                                </Col>
                                                <Col lg={12}>
                                                    <FormInput
                                                        type="email"
                                                        name="email"
                                                        label="Email"
                                                        placeholder="Your Email"
                                                        containerClass={'mb-3'}
                                                        register={register}
                                                        errors={errors}
                                                        control={control}
                                                        className="mt-1.5 w-full rounded-lg border border-slate-300 px-4 py-2.5 text-sm outline-none focus:border-[#26A2AB] focus:ring-1 focus:ring-[#26A2AB]"
                                                    />
                                                </Col>
                                                <Col lg={12}>
                                                    <FormInput
                                                        type="text"
                                                        name="Cnumber"
                                                        label="Contact Number"
                                                        maxLength={10}
                                                        placeholder="Your Contact Number"
                                                        containerClass={'mb-3'}
                                                        register={register}
                                                        errors={errors}
                                                        control={control}
                                                        className="mt-1.5 w-full rounded-lg border border-slate-300 px-4 py-2.5 text-sm outline-none focus:border-[#26A2AB] focus:ring-1 focus:ring-[#26A2AB]"
                                                    />
                                                </Col>
                                                <Col lg={12}>
                                                    <FormInput
                                                        type="textarea"
                                                        name="message"
                                                        label="Message"
                                                        placeholder="Type Your message..."
                                                        rows={5}
                                                        containerClass={'mb-3'}
                                                        register={register}
                                                        errors={errors}
                                                        control={control}
                                                    />
                                                </Col>

                                                <Col lg={12} className="mb-0 ">
                                                    {/* <ReCAPTCHA
                                                        ref={recaptchaRef} sitekey="6Lchm_4qAAAAAGOEl-D9UqjqMyFAAuYFvORjkwmw" onChange={onChange}
                                                    /> */}

                                                    <div className="recaptcha-container">
                                                        <ReCAPTCHA
                                                            ref={recaptchaRef}
                                                            sitekey="6Lchm_4qAAAAAGOEl-D9UqjqMyFAAuYFvORjkwmw"
                                                            onChange={onChange}
                                                        />
                                                    </div>


                                                    <Button type="submit" style={{ marginTop: 12, backgroundColor: colors.primary.teal }} disabled={loading}>
                                                        {loading ? (
                                                            <div className="spinner-border spinner-border-sm text-white" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        ) : (
                                                            'Send'
                                                        )}

                                                    </Button>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </>
                            )
                        ) : (<>
                            <div className="text-center p-5 bg-light rounded shadow-sm border border-success">
                                <div className="mb-3">
                                    <FeatherIcon icon="check-circle" size={48} className="text-success" />
                                </div>
                                <h4 className="text-success fw-bold">Thank You!</h4>
                                <p className="mt-3 text-muted fs-5">
                                    Your information has been successfully submitted. <br />
                                    Someone from our team will contact you within 24 hours.
                                </p>
                            </div>
                        </>
                        )}


                        {/* RIGHT - Info Section */}
                        {/* <div className="space-y-6"> */}
                        <div className="space-y-6 w-full max-w-lg mx-auto lg:mx-0">
                            {/* Help Topics */}
                            <div style={{
                                background: "linear-gradient(135deg, #24347D 0%, #26A2AB 100%)"
                            }} className="rounded-3xl border border-slate-200 bg-white p-4 sm:p-5 shadow-lg w-full">
                                <h3 className="text-xl font-bold text-white/90 pt-4  px-3">What can we help with?</h3>
                                <ul className="mt-2 px-4 py-2 space-y-2">
                                    <li className="flex items-start gap-3">
                                        <span className="mt-0 text-[#26A2AB] font-bold">✓</span>
                                        <span className="text-white/90 text-sm sm:text-base">Product demo & onboarding guidance</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className=" text-[#26A2AB] font-bold">✓</span>
                                        <span className="text-white/90 text-sm sm:text-base">CRM setup for leads, pipeline & email campaigns</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className=" text-[#26A2AB] font-bold">✓</span>
                                        <span className="text-white/90 text-sm sm:text-base">Support ticket workflow & AI routing</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className=" text-[#26A2AB] font-bold">✓</span>
                                        <span className="text-white/90 text-sm sm:text-base">White-label & agency partnerships</span>
                                    </li>
                                </ul>
                            </div>

                            {/* Quick Call Section - Fixed Gradient */}
                            {/* <div
                                className="rounded-3xl p-2 shadow-lg"
                                style={{
                                    background: "linear-gradient(135deg, #24347D 0%, #26A2AB 100%)"
                                }}
                            >
                                <h3 className="text-xl font-bold text-white pt-5  px-3">Prefer a quick call?</h3>
                                <p className="mt-2 text-white/90 text-sm px-3">
                                    Share your email and your preferred time—we'll reach out.
                                </p>

                                <div className="mt-3 flex flex-col px-3 sm:flex-row gap-3">
                                    <input
                                        type="email"
                                        className="flex-1 rounded-lg bg-white/95 px-4 py-3 text-sm text-slate-800 outline-none placeholder:text-slate-400 focus:ring-2 focus:ring-white/50"
                                        placeholder="your@email.com"
                                    />
                                    <button
                                        className="rounded-lg bg-white px-6 py-3 text-sm font-semibold transition-all hover:bg-slate-100 hover:shadow-md"
                                        style={{ color: "#24347D" }}
                                    >
                                        Send
                                    </button>
                                </div>

                                <p className="mt-3 px-3 text-xs text-white/70">
                                    We'll follow up within 24 hours to schedule your call.
                                </p>
                            </div> */}
                        </div>
                    </div>
                </main >

                <Container>
                    <Row className="mt-4 mb-7 align-items-center">
                        <Col md={4}>
                            <div className="d-flex px-md-1 px-lg-5 mb-md-0 mb-3">
                                <span className="bg-soft-primary avatar avatar-sm rounded icon icon-with-bg icon-xs text-primary me-3 flex-shrink-0">
                                    <FeatherIcon icon="mail" className="icon-dual-primary" />
                                </span>
                                <div className="flex-grow-1">
                                    <h5 className="m-0 fw-medium">Email</h5>
                                    <Link to="#" className="text-muted fw-normal h5 my-1">
                                        hello@salestrackify.com
                                    </Link>
                                </div>
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="d-flex px-md-1 px-lg-5 mb-md-0 mb-3">
                                <span className="bg-soft-orange avatar avatar-sm rounded icon icon-with-bg icon-xs text-orange me-3 flex-shrink-0">
                                    <FeatherIcon icon="phone-call" className="icon-dual-orange" />
                                </span>
                                <div className="flex-grow-1">
                                    <h5 className="m-0 fw-medium">Phone</h5>
                                    <Link to="#" className="text-muted fw-normal h5 my-1">
                                        +44 7775168068
                                    </Link>
                                </div>
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="d-flex px-md-1 px-lg-5 mb-md-0 mb-3">
                                <span className="bg-soft-info avatar avatar-sm rounded icon icon-with-bg icon-xs text-info me-3 flex-shrink-0">
                                    <FeatherIcon icon="map-pin" className="icon-dual-info" />
                                </span>
                                <div className="flex-grow-1">
                                    <h5 className="m-0 fw-medium">Address</h5>
                                    <Link to="#" className="text-muted fw-normal h5 my-1">
                                        Rugby, UK.
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ContactUs;
